// @flow

import { RECEIVED_COMPONENT_SETTINGS } from './constants';
import { type ReceivedComponentSettings } from './actions';
import { type ComponentSettings } from '../../types/settings';

const initialState: ComponentSettings = {
  carblock: {
    button_text: '',
    price_label: '',
    price_duration: '',
    contract_duration_abbrv: '',
    mileage_abbrv: '',
    year_abbrv: '',
    and_abbrv: '',
    per_abbrv: '',
    roadtax_note: '',
    contract_prefix: '',
    contract_postfix: '',
    delivery_time: '',
    delivery_time_approximately: '',
    delivery_time_duration_single: '',
    delivery_time_duration_plural: '',
    reserved_text: '',
    not_available_text: '',
  },
  faq_category_list: {
    choose_a_category_text: '',
  },
  faq_search_field: {
    search_button_text: '',
    search_field_placeholder: '',
  },
  feedback: {
    title: '',
    true: '',
    false: '',
    partial: '',
  },
  list: {
    collapsible_button: {
      expanded: '',
      collapsed: '',
    },
    visible_item_count: {
      default: '',
      sm: '',
      md: '',
      lg: '',
      xl: '',
    },
  },
  pdb_cta_block: {
    add_to_comparison_text: '',
    button_text: '',
    delivery_time: '',
    delivery_time_approximately: '',
    delivery_time_duration_single: '',
    delivery_time_duration_plural: '',
    max_items_in_comparison: 3,
    remove_from_comparison_text: '',
    vbmr_text: '',
    form_data: {},
  },
  pdb_gallery: {
    disclaimer_text: '',
    theater_button_text: '',
  },
  pdb_info: {
    base_price_label: '',
    contract_duration_abbrv: '',
    mileage_abbrv: '',
    year_abbrv: '',
    roadtax_note: '',
    and_abbrv: '',
    per_abbrv: '',
    contract_prefix: '',
    contract_postfix: '',
    available_label: '',
    occasion_link_text_single: '',
    occasion_link_text_plural: '',
  },
  pdb_specs: {
    title: '',
    keys: {},
    fuelinfo: {
      title: '',
      content: '',
    },
    doors: '',
  },
  pdb_packages: {
    button_text: 'Nu samenstellen',
    price_label: 'Vanafprijs p.m.',
    unique_features_label: 'Unieke features in dit pakket:',
    package_contents_button_label: 'Pakketinhoud tonen',
  },
  review: {
    based_on: '',
    reviews: '',
    all_reviews_link_text: '',
    rating: {
      rating_0: '',
      rating_1: '',
      rating_2: '',
      rating_3: '',
      rating_4: '',
      rating_5: '',
      rating_6: '',
      rating_7: '',
      rating_8: '',
      rating_9: '',
    },
    score: '0',
    review_count: '0',
  },
  wysiwyg: {
    collapsible_button: {
      expanded: '',
      collapsed: '',
    },
  },
};

export type State = typeof initialState;

export default (state: State = initialState, action: ReceivedComponentSettings): State => {
  switch (action.type) {
    case RECEIVED_COMPONENT_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
